/* eslint-disable import/prefer-default-export */

import { toast } from 'react-toastify';

import {
  ADD_TEAM_MEMBER_CLICKED,
  CANCEL_NEW_INVITATION,
  NEW_INVITATION_FIRST_NAME_CHANGED,
  NEW_INVITATION_LAST_NAME_CHANGED,
  NEW_INVITATION_EMAIL_CHANGED,
  NEW_INVITATION_ROLE_ID_CHANGED,
  NEW_INVITATION_COMPANY_CHANGED,
  NEW_INVITATION_VENUE_OWNERSHIP_CLICKED,
  NEW_INVITATION_CREATION_SUCCESS,
  NEW_INVITATION_ERRORS_CHANGED,
  NEW_INVITATION_SUBMITTING,
  NEW_INVITATION_ENABLE_ALL_VENUES_CLICK,
  NEW_INVITATION_DISABLE_ALL_VENUES_CLICK,
  EDIT_TEAM_MANAGEABLE_CLICKED,
  EDIT_TEAM_MANAGEABLE_CANCELED,
  TEAM_MANAGEABLE_DELETED,
  TEAM_MANAGEABLE_TO_EDIT_FIRST_NAME_CHANGED,
  TEAM_MANAGEABLE_TO_EDIT_LAST_NAME_CHANGED,
  TEAM_MANAGEABLE_TO_EDIT_EMAIL_CHANGED,
  TEAM_MANAGEABLE_TO_EDIT_ROLE_ID_CHANGED,
  TEAM_MANAGEABLE_TO_EDIT_VENUE_OWNERSHIP_CLICKED,
  TEAM_MANAGEABLE_TO_EDIT_ENABLE_ALL_VENUES_CLICK,
  TEAM_MANAGEABLE_TO_EDIT_DISABLE_ALL_VENUES_CLICK,
  TEAM_MANAGEABLE_TO_EDIT_UPDATED,
  TEAM_MANAGEABLE_TO_EDIT_ERRORS_CHANGED,
  TEAM_MANAGEABLE_TO_EDIT_COMPANY_CHANGED,
  SEARCH_TERM_CHANGED,
  ROLE_FILTER_CHANGED,
  VENUE_FILTER_CHANGED,
  CURRENT_PAGE_CHANGED,
  PAGE_SIZE_CHANGED,
  TOGGLE_MEMBER_SELECTION,
  SELECT_ALL_MEMBERS,
  DESELECT_ALL_MEMBERS,
  CLEAR_FILTERS,
  SORT_CHANGED,
  OPEN_MEMBER_MODAL,
  CLOSE_MEMBER_MODAL,
  TEAM_FUNCTION_CREATED,
  TEAM_FUNCTION_UPDATED,
  TEAM_FUNCTION_DELETED,
  TEAM_FUNCTION_FILTER_CHANGED,
  NEW_INVITATION_TEAM_FUNCTION_IDS_CHANGED,
  TEAM_MANAGEABLE_TO_EDIT_TEAM_FUNCTION_IDS_CHANGED
} from '../constants/teamManagerConstants';

const axios = require('axios').default;

export const addTeamMemberClicked = () => ({
  type: ADD_TEAM_MEMBER_CLICKED
});

export const cancelNewInvitation = () => ({
  type: CANCEL_NEW_INVITATION
});

export const newInvitationFirstNameChanged = (firstName) => ({
  type: NEW_INVITATION_FIRST_NAME_CHANGED,
  firstName
});

export const newInvitationLastNameChanged = (lastName) => ({
  type: NEW_INVITATION_LAST_NAME_CHANGED,
  lastName
});

export const newInvitationEmailChanged = (email) => ({
  type: NEW_INVITATION_EMAIL_CHANGED,
  email
});

export const newInvitationRoleIdChanged = (roleId) => ({
  type: NEW_INVITATION_ROLE_ID_CHANGED,
  roleId
});

export const newInvitationVenueOwnershipClicked = (venueOwnershipId) => ({
  type: NEW_INVITATION_VENUE_OWNERSHIP_CLICKED,
  venueOwnershipId
});

export const newInvitationSubmittingChanged = (submitting) => ({
  type: NEW_INVITATION_SUBMITTING,
  submitting
});

export const createInvitation = (dispatch, csrfToken, venueOwnerships, invitation, team) => {
  return dispatch => {
    dispatch(newInvitationErrorsChanged([]));
    dispatch(newInvitationSubmittingChanged(true));
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.post("/teams/" + team.id + "/admin_invitations", {
        invitation: {
          type: "Invitations::TeamMembership",
          first_name: invitation.firstName,
          last_name: invitation.lastName,
          email: invitation.email,
          role_id: invitation.roleId,
          venue_ownership_ids: invitation.venueOwnershipIds,
          company: invitation.company,
          team_function_ids: invitation.teamFunctionIds || []
        }
      })
      .then(({ data }) => {
        dispatch(newInvitationCreationSuccess(data));
        toast.success('Team member invited.', {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: true,
          autoClose: 3000,
          hideProgressBar: true
        });
      })
      .catch((error) => {
        dispatch(newInvitationErrorsChanged(error.response.data));
      });
  };
};

export const newInvitationCreationSuccess = (invitation) => ({
  type: NEW_INVITATION_CREATION_SUCCESS,
  invitation
});

export const newInvitationErrorsChanged = (errors) => ({
  type: NEW_INVITATION_ERRORS_CHANGED,
  errors
});

export const newInvitationEnableAllVenuesClicked = (venueOwnerships) => ({
  type: NEW_INVITATION_ENABLE_ALL_VENUES_CLICK,
  venueOwnerships
});

export const newInvitationDisableAllVenuesClicked = () => ({
  type: NEW_INVITATION_DISABLE_ALL_VENUES_CLICK
});

export const editTeamManageable = (teamManageable, venueOwnerships) => ({
  type: EDIT_TEAM_MANAGEABLE_CLICKED,
  teamManageable,
  venueOwnerships
});

export const cancelEditTeamManageable = (teamManageable) => ({
  type: EDIT_TEAM_MANAGEABLE_CANCELED,
  teamManageable
});

export const deleteTeamManageable = (dispatch, csrfToken, team, teamManageable, closeModal) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    var deleteUrl;
    if(teamManageable.type_for_ui === "Invitations::TeamMembership"){
      deleteUrl = "/teams/" + team.id + "/admin_invitations/" + teamManageable.id;
    } else {
      deleteUrl = "/teams/" + team.id + "/team_memberships/" + teamManageable.id;
    }

    return axios.delete(deleteUrl)
      .then(() => {
        // Use the original teamManageable so reducers can reliably remove it
        dispatch(teamManageableDeleted(teamManageable));
        closeModal();
        toast.success('Team member deleted.', {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: true,
          autoClose: 3000,
          hideProgressBar: true
        });
      })
      .catch((error) => {
        const serverMessage = error && error.response && error.response.data && error.response.data[0];
        toast.error(serverMessage || 'Unable to delete team member. Please try again.', {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: true,
          autoClose: 5000,
          hideProgressBar: true
        });
      });
  };
};

export const teamManageableDeleted = (teamManageable) => ({
  type: TEAM_MANAGEABLE_DELETED,
  teamManageable
});

export const teamManageableToEditUpdateFirstName = (firstName) => ({
  type: TEAM_MANAGEABLE_TO_EDIT_FIRST_NAME_CHANGED,
  firstName
});

export const teamManageableToEditUpdateLastName = (lastName) => ({
  type: TEAM_MANAGEABLE_TO_EDIT_LAST_NAME_CHANGED,
  lastName
});

export const teamManageableToEditUpdateEmail = (email) => ({
  type: TEAM_MANAGEABLE_TO_EDIT_EMAIL_CHANGED,
  email
});

export const teamManageableToEditUpdateRoleId = (roleId) => ({
  type: TEAM_MANAGEABLE_TO_EDIT_ROLE_ID_CHANGED,
  roleId
});

export const teamManageableToEditVenueOwnershipClicked = (venueOwnershipId) => ({
  type: TEAM_MANAGEABLE_TO_EDIT_VENUE_OWNERSHIP_CLICKED,
  venueOwnershipId
});

export const teamManageableToEditEnableAllVenuesClicked = (venueOwnerships) => ({
  type: TEAM_MANAGEABLE_TO_EDIT_ENABLE_ALL_VENUES_CLICK,
  venueOwnerships
});

export const teamManageableToEditDisableAllVenuesClicked = () => ({
  type: TEAM_MANAGEABLE_TO_EDIT_DISABLE_ALL_VENUES_CLICK
});

export const submitUpdateTeamManageable = (dispatch, csrfToken, team, teamManageable) => {
  dispatch(teamManageableToEditErrorsChanged([]));

  var updateUrl;
  var params;

  if(teamManageable.type_for_ui === "Invitations::TeamMembership"){
    updateUrl = "/teams/" + team.id + "/admin_invitations/" + teamManageable.id;
    params    = {
      invitation: {
        first_name: teamManageable.first_name,
        last_name: teamManageable.last_name,
        email: teamManageable.email,
        role_id: teamManageable.role_id,
        venue_ownership_ids: teamManageable.venue_ownership_ids,
        company: teamManageable.company,
        team_function_ids: teamManageable.team_function_ids || []
      }
    }
  } else {
    updateUrl = "/teams/" + team.id + "/team_memberships/" + teamManageable.id;
    params    = {
      team_membership: {
        first_name: teamManageable.first_name,
        last_name: teamManageable.last_name,
        email: teamManageable.email,
        role_id: teamManageable.role_id,
        venue_ownership_ids: teamManageable.venue_ownership_ids,
        company: teamManageable.company,
        team_function_ids: teamManageable.team_function_ids || []
      }
    }
  }

  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.patch(updateUrl, params)
      .then(({ data }) => {
        dispatch(teamManageableToEditUpdated(data));
        toast.success('Team member updated.', {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: true,
          autoClose: 3000,
          hideProgressBar: true
        });
      })
      .catch((error) => {
        dispatch(teamManageableToEditErrorsChanged(error.response.data));
      });
  };
};

export const teamManageableToEditUpdated = (teamManageable) => ({
  type: TEAM_MANAGEABLE_TO_EDIT_UPDATED,
  teamManageable
});

export const teamManageableToEditErrorsChanged = (errors) => ({
  type: TEAM_MANAGEABLE_TO_EDIT_ERRORS_CHANGED,
  errors
});

export const resetPasswordForEmail = (dispatch, csrfToken, teamMembership, team) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.post("/teams/" + team.id + "/team_memberships/" + teamMembership.id + "/reset_password")
      .then(() => {
        toast.success('Password reset instructions have been sent to the user.', {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      })
      .catch(() => {
        toast.error('Unable to send password reset. Please try again.', {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: true,
          autoClose: 5000,
          hideProgressBar: true
        });
      });
  };
};

export const newInvitationCompanyChanged = (company) => ({
  type: NEW_INVITATION_COMPANY_CHANGED,
  company
});

export const teamManageableToEditCompanyChanged = (company) => ({
  type: TEAM_MANAGEABLE_TO_EDIT_COMPANY_CHANGED,
  company
});

// Search, Filter, Pagination Action Creators
export const searchTermChanged = (searchTerm) => ({
  type: SEARCH_TERM_CHANGED,
  searchTerm
});

export const roleFilterChanged = (roleFilter) => ({
  type: ROLE_FILTER_CHANGED,
  roleFilter
});

export const venueFilterChanged = (venueFilter) => ({
  type: VENUE_FILTER_CHANGED,
  venueFilter
});

export const currentPageChanged = (currentPage) => ({
  type: CURRENT_PAGE_CHANGED,
  currentPage
});

export const pageSizeChanged = (pageSize) => ({
  type: PAGE_SIZE_CHANGED,
  pageSize
});

export const toggleMemberSelection = (memberId) => ({
  type: TOGGLE_MEMBER_SELECTION,
  memberId
});

export const selectAllMembers = (memberIds) => ({
  type: SELECT_ALL_MEMBERS,
  memberIds
});

export const deselectAllMembers = () => ({
  type: DESELECT_ALL_MEMBERS
});

export const clearFilters = () => ({
  type: CLEAR_FILTERS
});

export const sortChanged = (sortBy, sortDirection) => ({
  type: SORT_CHANGED,
  sortBy,
  sortDirection
});

export const openMemberModal = (mode = 'add') => ({
  type: OPEN_MEMBER_MODAL,
  mode
});

export const closeMemberModal = () => ({
  type: CLOSE_MEMBER_MODAL
});

// Team Function CRUD

export const createTeamFunction = (csrfToken, team, name) => {
  return (dispatch) => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    return axios
      .post(`/teams/${team.id}/team_functions`, { team_function: { name } })
      .then(({ data }) => {
        dispatch({ type: TEAM_FUNCTION_CREATED, teamFunction: data });
        toast.success('Function added.', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
          hideProgressBar: true
        });
        return data;
      })
      .catch((error) => {
        const message = (error && error.response && error.response.data && error.response.data[0]) || 'Unable to add function.';
        toast.error(message, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 5000,
          hideProgressBar: true
        });
        throw error;
      });
  };
};

export const updateTeamFunction = (csrfToken, team, teamFunction, name) => {
  return (dispatch) => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    return axios
      .patch(`/teams/${team.id}/team_functions/${teamFunction.id}`, { team_function: { name } })
      .then(({ data }) => {
        dispatch({ type: TEAM_FUNCTION_UPDATED, teamFunction: data });
        toast.success('Function updated.', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
          hideProgressBar: true
        });
        return data;
      })
      .catch((error) => {
        const message = (error && error.response && error.response.data && error.response.data[0]) || 'Unable to update function.';
        toast.error(message, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 5000,
          hideProgressBar: true
        });
        throw error;
      });
  };
};

export const deleteTeamFunction = (csrfToken, team, teamFunction) => {
  return (dispatch) => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    return axios
      .delete(`/teams/${team.id}/team_functions/${teamFunction.id}`)
      .then(() => {
        dispatch({ type: TEAM_FUNCTION_DELETED, teamFunctionId: teamFunction.id });
        toast.success('Function deleted.', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
          hideProgressBar: true
        });
      })
      .catch(() => {
        toast.error('Unable to delete function.', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 5000,
          hideProgressBar: true
        });
      });
  };
};

export const teamFunctionFilterChanged = (teamFunctionFilter) => ({
  type: TEAM_FUNCTION_FILTER_CHANGED,
  teamFunctionFilter
});

export const newInvitationTeamFunctionIdsChanged = (teamFunctionIds) => ({
  type: NEW_INVITATION_TEAM_FUNCTION_IDS_CHANGED,
  teamFunctionIds
});

export const teamManageableToEditTeamFunctionIdsChanged = (teamFunctionIds) => ({
  type: TEAM_MANAGEABLE_TO_EDIT_TEAM_FUNCTION_IDS_CHANGED,
  teamFunctionIds
});
